import {combineReducers} from 'redux'
import urlInfo from './urlInfoReducer'
import defaultApp from './defaultAppReducer'
import moduleQV from './moduleQVReducer'
export default combineReducers({
  urlInfo,
  defaultApp,
  moduleQV,
})
